import { useState, useEffect } from 'react';
import { settingsService } from '../services/settingsService';

/**
 * Hook that checks the system setting 'scanning.enableGlobalBarcodeCapture'.
 * Returns whether the global barcode scanner (useSimpleBarcodeScanner + MobileBarcodeCaptureInput)
 * should be enabled.
 *
 * Default: false (scanner disabled unless explicitly enabled in settings).
 */
export function useBarcodeScannerEnabled(): boolean {
  const [enabled, setEnabled] = useState<boolean>(false);

  useEffect(() => {
    let cancelled = false;

    const loadSetting = async () => {
      try {
        const setting = await settingsService.getSystemSetting('scanning.enableGlobalBarcodeCapture');
        if (!cancelled) {
          if (setting && setting.value !== null && setting.value !== undefined) {
            // Handle various truthy representations
            const val = setting.value.toString().toLowerCase();
            setEnabled(val === 'true' || val === '1' || val === 'ja');
          } else {
            setEnabled(false);
          }
        }
      } catch (err) {
        console.warn('Could not load scanning.enableGlobalBarcodeCapture setting, defaulting to false:', err);
        if (!cancelled) {
          setEnabled(false);
        }
      }
    };

    loadSetting();

    return () => { cancelled = true; };
  }, []);

  return enabled;
}
